import React, { useContext, useMemo } from "react";

export const GatesContext = React.createContext();

export const useGatesConsumer = () => {
  return useContext(GatesContext);
};

export function GatesProvider({ user = null, policies = {}, defaultHandler, children, ...rest }) {
  const value = useMemo(() => {
    return {
      user,
      policies,
      defaultHandler,
      additional: { ...rest },
    };
  }, [defaultHandler, policies, rest, user]);

  return (
    <>
      <GatesContext.Provider value={value}>{children}</GatesContext.Provider>
    </>
  );
}
